<template>
  <a-modal
    title="分配房间"
    :width="800"
    :maskClosable="false"
    :confirmLoading="saving"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel">
    <div class="assign-room">
      <a-descriptions :column="2" size="small" class="assign-room-stay" v-if="applyInfo">
        <a-descriptions-item label="申请人">{{applyInfo.name || '—'}}</a-descriptions-item>
        <a-descriptions-item label="房型">{{applyInfo.roomType || '—'}}</a-descriptions-item>
        <a-descriptions-item label="入住人数">{{applyInfo.num ? applyInfo.num + ' 人' : '—'}}</a-descriptions-item>
        <a-descriptions-item label="房间数">{{applyInfo.roomNum ? applyInfo.roomNum + ' 间' : '—'}}</a-descriptions-item>
        <a-descriptions-item label="申请入住时间">{{applyInfo.startTime || '—'}}</a-descriptions-item>
        <a-descriptions-item label="申请离开时间">{{applyInfo.endTime || '—'}}</a-descriptions-item>
        <a-descriptions-item label="入住人员" :span="2">
          <div class="assign-checkin-item" v-for="(u, i) in checkinUsers" :key="i">
            <span class="assign-checkin-name">{{u.name}}</span>
            <span class="assign-checkin-mobile">{{u.mobile}}</span>
          </div>
          <span v-if="checkinUsers.length == 0">—</span>
        </a-descriptions-item>
        <a-descriptions-item label="申请备注" :span="2" v-if="applyInfo.note">{{applyInfo.note}}</a-descriptions-item>
        <a-descriptions-item label="附件" :span="2" v-if="annexList.length > 0">
          <div class="assign-annex-item" v-for="(f, i) in annexList" :key="i" @click="openAnnex(f)">
            <a-icon :type="f.type === 'image' ? 'picture' : 'paper-clip'"/>
            {{f.fileName || '附件'}}
          </div>
        </a-descriptions-item>
      </a-descriptions>
      <div class="assign-section-title">分配信息</div>
      <div class="assign-form-row">
        <span class="assign-form-label"><i class="assign-required">*</i>入住时间</span>
        <a-date-picker
          class="assign-form-picker"
          v-model="assignForm.checkinTime"
          format="YYYY-MM-DD HH:mm"
          value-format="YYYY-MM-DD HH:mm"
          :show-time="{ format: 'HH:mm' }"
          placeholder="选择入住时间"/>
        <span class="assign-form-label assign-form-label-gap"><i class="assign-required">*</i>离开时间</span>
        <a-date-picker
          class="assign-form-picker"
          v-model="assignForm.checkoutTime"
          format="YYYY-MM-DD HH:mm"
          value-format="YYYY-MM-DD HH:mm"
          :show-time="{ format: 'HH:mm' }"
          placeholder="选择离开时间"/>
      </div>
      <div class="assign-form-row">
        <span class="assign-form-label">开锁状态</span>
        <a-tag v-if="filledUnlockStatus" :color="getUnlockStatusColor(filledUnlockStatus.key)">{{filledUnlockStatus.text}}</a-tag>
        <span v-else class="assign-unlock-tip">填写入住/离开时间后自动判定</span>
      </div>
      <div class="assign-form-row assign-form-row-top">
        <span class="assign-form-label">分配备注</span>
        <a-textarea
          class="assign-form-remark"
          v-model="assignForm.remark"
          placeholder="选填，最多200字"
          :rows="2"
          :max-length="200"/>
      </div>
      <div class="assign-room-head">
        <span class="assign-room-tip">填写开锁手机号并选择房间，同一手机号可分配多间房间，同一房间可多人入住</span>
        <a-button type="link" icon="plus" @click="addItem">添加</a-button>
      </div>
      <div class="assign-room-row" v-for="(item, i) in list" :key="i">
        <a-input class="assign-room-name" v-model="item.name" placeholder="姓名" :max-length="20"/>
        <a-input class="assign-room-phone" v-model="item.phone" placeholder="手机号" :max-length="11"/>
        <a-select
          class="assign-room-select"
          v-model="item.roomId"
          placeholder="选择房间"
          show-search
          :filter-option="filterRoom">
          <!-- 1.x 的 Select 无 loading 属性，用 notFoundContent 区分加载中/无数据 -->
          <template slot="notFoundContent">
            <a-spin v-if="roomLoading" size="small"/>
            <span v-else>暂无可分配的房间</span>
          </template>
          <a-select-option v-for="room in rooms" :key="room.roomId" :value="room.roomId">
            <span class="assign-room-label">{{getRoomLabel(room)}}</span>
            <a-tag v-if="room.assignedNow.length > 0" color="orange">在住 {{room.assignedNow.length}} 人</a-tag>
          </a-select-option>
        </a-select>
        <a-icon type="delete" class="assign-room-del" @click="removeItem(i)" v-if="list.length > 1"/>
      </div>
      <a-empty class="assign-room-empty" description="暂无可分配的房间" v-if="!roomLoading && rooms.length == 0"/>
    </div>
  </a-modal>
</template>

<script>
    import moment from "moment";
    import {MOBILE_REG} from "@/components/custom-form/formItems";

    export default {
        name: "assign-room-modal",
        props: {
            visible: Boolean,
            // 当前操作的申请记录（客房申请）
            apply: Object,
        },
        data() {
            return {
                saving: false,
                roomLoading: false,
                rooms: [],
                list: [],
                // 申请信息（detail 表单字段），展示用
                applyInfo: null,
                // 分配信息（真实住宿时间 + 分配备注）：入住/离开时间默认取用户申请时间
                assignForm: {
                    checkinTime: undefined,
                    checkoutTime: undefined,
                    remark: ''
                },
                // 入住人员列表（detail.checkin_user_list）
                checkinUsers: [],
                // 附件列表（detail.annex）
                annexList: [],
            }
        },
        computed: {
            // 按当前填写的入住/离开时间实时判定开锁状态（申请时间仅作参考默认值）
            filledUnlockStatus() {
                return this.getUnlockStatus(this.assignForm.checkinTime, this.assignForm.checkoutTime);
            }
        },
        watch: {
            visible(val) {
                if(val) {
                    this.init();
                }
            }
        },
        methods: {
            init() {
                this.saving = false;
                this.initApplyInfo();
                this.initAssignForm();
                this.initList();
                // 房间列表缓存复用：仅无缓存时拉取，避免每次打开弹窗都请求（保存成功后清缓存重新获取）
                if(this.rooms.length == 0) {
                    this.getRooms();
                }
            },
            // 申请信息（detail 表单固定字段：name 申请人、num 入住人数、room_num 房间数、
            // room_type 房型、start_time 申请入住时间、end_time 申请离开时间、note 备注）——仅参考展示
            initApplyInfo() {
                let detail = this.getApplyDetail();
                this.applyInfo = detail ? {
                    name: detail.name || '',
                    num: detail.num || '',
                    roomNum: detail.room_num || '',
                    roomType: detail.room_type || '',
                    startTime: detail.start_time || '',
                    endTime: detail.end_time || '',
                    note: detail.note || ''
                } : null;
                // 入住人员与附件（detail 表单数据）
                this.checkinUsers = detail && Array.isArray(detail.checkin_user_list) ? detail.checkin_user_list : [];
                this.annexList = detail && Array.isArray(detail.annex) ? detail.annex : [];
            },
            // 分配信息初始化：优先回显上次保存的填写值，否则默认取用户申请时间
            initAssignForm() {
                let select = this.getAssignSelect();
                let detail = this.getApplyDetail();
                this.assignForm = {
                    checkinTime: (select && select.checkinTime) || this.normalizeTime(detail && detail.start_time),
                    checkoutTime: (select && select.checkoutTime) || this.normalizeTime(detail && detail.end_time),
                    remark: (select && select.remark) || ''
                };
            },
            // 解析已保存的客房分配 select JSON（type=room），异常/非客房分配返回 null
            getAssignSelect() {
                if(!this.apply || !this.apply.select) return null;
                try {
                    let select = JSON.parse(this.apply.select);
                    return select && select.type === 'room' ? select : null;
                } catch (e) {
                    return null;
                }
            },
            // 申请时间统一为 "YYYY-MM-DD HH:mm"（与时间选择器 value-format 一致，保证默认值可回填）
            normalizeTime(str) {
                if(!str) return undefined;
                let m = moment(String(str).replace(/-/g, '/'));
                return m.isValid() ? m.format('YYYY-MM-DD HH:mm') : undefined;
            },
            /**
             * 计算当前开锁状态：未开始（before）/ 可开锁（ing）/ 已结束（after）/ 未限制（''）
             * 判定依据与小程序端一致：当前时间是否处于申请的入住时间段内
             */
            getUnlockStatus(startTime, endTime) {
                if (!startTime || !endTime) return null;
                const start = new Date(String(startTime).replace(/-/g, '/')).getTime();
                const end = new Date(String(endTime).replace(/-/g, '/')).getTime();
                if (isNaN(start) || isNaN(end)) return null;
                const now = Date.now();
                if (now < start) return {key: 'before', text: `未开始（${startTime}起可开锁）`};
                if (now > end) return {key: 'after', text: '已结束（入住时间已过）'};
                return {key: 'ing', text: '可开锁（入住时段内）'};
            },
            getUnlockStatusColor(key) {
                return {before: 'orange', ing: 'green', after: 'red'}[key] || 'default';
            },
            // 打开附件（新窗口，图片与文件统一处理）
            openAnnex(file) {
                if(file && file.url) {
                    window.open(file.url, '_blank');
                }
            },
            // 解析申请表单数据 JSON
            getApplyDetail() {
                if(!this.apply || !this.apply.detail) return null;
                try {
                    return JSON.parse(this.apply.detail);
                } catch (e) {
                    return null;
                }
            },
            // 初始化分配列表：优先回显已有分配（select 覆盖保存前便于修改），否则按入住人员每人预填一行
            initList() {
                let list = [];
                let apply = this.apply;
                let users = this.getCheckinUsers();
                if(apply && apply.select) {
                    try {
                        let select = JSON.parse(apply.select);
                        if(select && Array.isArray(select.rooms)) {
                            list = select.rooms.map(item => {
                                // 姓名：优先取已保存的（手动添加人员），老数据按手机号从入住人员列表匹配
                                let user = users.find(u => u.mobile === item.phone);
                                return {
                                    name: item.name || (user && user.name) || '',
                                    phone: item.phone || '',
                                    roomId: item.roomId,
                                    roomName: item.roomName || ''
                                };
                            });
                        }
                    } catch (e) {
                        // select 非 rooms JSON 时忽略回显
                    }
                }
                if(list.length == 0) {
                    // 入住人员为表单 checkin 控件固定字段 checkin_user_list，每项 {name, mobile}
                    list = users.map(user => {
                        return {name: user.name || '', phone: user.mobile || user.phone || '', roomId: undefined, roomName: ''}
                    });
                    if(list.length == 0) {
                        list = [{name: '', phone: '', roomId: undefined, roomName: ''}];
                    }
                }
                this.list = list;
            },
            // 入住人员列表（detail.checkin_user_list），结构异常时返回空数组
            getCheckinUsers() {
                let detail = this.getApplyDetail();
                return detail && Array.isArray(detail.checkin_user_list) ? detail.checkin_user_list : [];
            },
            // 可分配房间列表（文档 3.7 新增 bindable-rooms）：服务端只返回已绑定门锁的本地房间，
            // roomId 即平台房间ID（与 select.rooms[].roomId 对齐）；include_assigned=1 附 assigned_now
            // （当前在住分配数组），同一房间可多人入住，选项上展示在住人数
            getRooms() {
                this.roomLoading = true;
                this.$axios('/admin/hotel-room/bindable-rooms?include_assigned=1').then(res => {
                    try {
                        let list = this.getRoomList(res);
                        this.rooms = (Array.isArray(list) ? list : []).map(room => this.normalizeRoom(room)).filter(room => room.roomId);
                    } catch (e) {
                        // 数据处理异常时置空列表，保证下方 loading 复位不被跳过
                        console.error('房间列表数据处理异常', e);
                        this.rooms = [];
                    }
                    this.roomLoading = false;
                }, () => {
                    this.roomLoading = false;
                });
            },
            // 从响应中提取房间数组：兼容 {data:[...]} / {data:{list:[...]}} / 直接返回数组等实际返回结构
            getRoomList(res) {
                if(Array.isArray(res)) return res;
                if(Array.isArray(res.data)) return res.data;
                let data = res.data || {};
                return data.list || data.rooms || data.rows || [];
            },
            // 归一化 bindable-rooms 数据：roomName 为完整房间名，assigned_now 为在住分配
            normalizeRoom(room) {
                return {
                    roomId: room.roomId || '',
                    roomName: room.roomName || room.name || '',
                    areaName: room.area_name || '',
                    floor: room.floor || '',
                    assignedNow: Array.isArray(room.assigned_now) ? room.assigned_now : []
                };
            },
            // 房间展示名：接口返回的完整房间名（如 "云中轩-1层-101"）
            getRoomLabel(room) {
                return room.roomName;
            },
            // 自定义过滤：按房间名（完整房间名）子串匹配
            // 不用默认 children 过滤——选项内含 a-tag 组件节点，默认文本提取不可靠会筛不出结果
            filterRoom(input, option) {
                let room = this.rooms.find(r => r.roomId === option.key);
                if(!room) return true;
                return this.getRoomLabel(room).toLowerCase().indexOf((input || '').toLowerCase()) > -1;
            },
            addItem() {
                this.list.push({name: '', phone: '', roomId: undefined, roomName: ''});
            },
            removeItem(index) {
                this.list.splice(index, 1);
            },
            handleCancel() {
                this.$emit('cancel');
            },
            // 校验并组装 rooms 数据，校验不通过返回 null
            getAssignRooms() {
                let rooms = [];
                for(let i = 0, l = this.list.length; i < l; i ++) {
                    let item = this.list[i];
                    let phone = (item.phone || '').trim();
                    if(!phone && !item.roomId) {
                        // 整行未填写时跳过
                        continue;
                    }
                    if(!phone) {
                        this.$message.warning(`第${i + 1}行请填写手机号`);
                        return null;
                    }
                    if(!new RegExp(MOBILE_REG).test(phone)) {
                        this.$message.warning(`第${i + 1}行手机号格式不正确`);
                        return null;
                    }
                    if(!item.roomId) {
                        this.$message.warning(`第${i + 1}行请选择房间`);
                        return null;
                    }
                    let room = this.rooms.find(r => r.roomId === item.roomId);
                    rooms.push({
                        phone: phone,
                        roomId: item.roomId,
                        // 保存完整房间名（楼栋-楼层-房号），与下拉选项展示一致，小程序端同步展示
                        roomName: room ? this.getRoomLabel(room) : (item.roomName || ''),
                        // 入住人姓名，供详情/小程序展示（手动添加的行可为空）
                        name: item.name || ''
                    });
                }
                if(rooms.length == 0) {
                    this.$message.warning('请至少分配一间房间');
                    return null;
                }
                return rooms;
            },
            handleOk() {
                if(this.saving) return;
                // 真实住宿时间必填，开锁状态由该时间段决定
                if(!this.assignForm.checkinTime) {
                    this.$message.warning('请填写入住时间');
                    return;
                }
                if(!this.assignForm.checkoutTime) {
                    this.$message.warning('请填写离开时间');
                    return;
                }
                let checkin = new Date(String(this.assignForm.checkinTime).replace(/-/g, '/')).getTime();
                let checkout = new Date(String(this.assignForm.checkoutTime).replace(/-/g, '/')).getTime();
                if(checkout <= checkin) {
                    this.$message.warning('离开时间需晚于入住时间');
                    return;
                }
                let rooms = this.getAssignRooms();
                if(!rooms) return;
                this.saving = true;
                // 保存到 apply.select，与其他分配类型（car/box）格式对齐，type 标识客房分配；
                // checkinTime/checkoutTime 为真实住宿时间（开锁拦截依据），remark 为分配备注
                this.$axios({
                    url: `/admin/apply/${this.apply.id}`,
                    method: 'PATCH',
                    data: {select: JSON.stringify({
                        type: 'room',
                        checkinTime: this.assignForm.checkinTime,
                        checkoutTime: this.assignForm.checkoutTime,
                        remark: (this.assignForm.remark || '').trim(),
                        rooms
                    })}
                }).then(() => {
                    this.saving = false;
                    this.$message.success('分配成功');
                    // 清空房间缓存：本次分配影响房态，下次打开弹窗重新拉取最新列表
                    this.rooms = [];
                    this.$emit('success');
                }, () => {
                    this.saving = false;
                });
            },
        }
    }
</script>

<style scoped lang="less">
    .assign-section-title {
        font-weight: bold;
        margin-bottom: @padding-xs;
    }
    .assign-form-row {
        display: flex;
        align-items: center;
        margin-bottom: @padding-xs;
        // 备注行 label 顶部对齐
        &.assign-form-row-top {
            align-items: flex-start;
            .assign-form-label {
                padding-top: 5px;
            }
        }
    }
    .assign-form-label {
        width: 70px;
        flex-shrink: 0;
        color: @text-color-secondary;
    }
    .assign-required {
        color: @error-color;
        font-style: normal;
        margin-right: 2px;
    }
    .assign-form-picker {
        width: 220px;
    }
    .assign-form-label-gap {
        margin-left: @padding-md;
    }
    .assign-unlock-tip {
        color: @text-color-secondary;
    }
    .assign-form-remark {
        flex: 1;
        min-width: 0;
    }
    .assign-room-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: @padding-sm;
    }
    .assign-room-tip {
        color: @text-color-secondary;
    }
    .assign-room-stay {
        margin-bottom: @padding-xs;
        /deep/ .ant-descriptions-item-label {
            color: @text-color-secondary;
            // 多行内容（如入住人员列表）时 label 顶部对齐
            vertical-align: top;
        }
    }
    .assign-room-row {
        display: flex;
        align-items: center;
        &:not(:first-of-type) {
            margin-top: @padding-xs;
        }
    }
    .assign-room-name {
        width: 110px;
        flex-shrink: 0;
        margin-right: @padding-xs;
    }
    .assign-room-phone {
        width: 180px;
        margin-right: @padding-xs;
    }
    .assign-room-select {
        flex: 1;
        min-width: 0;
    }
    .assign-room-del {
        margin-left: @padding-xs;
        color: @text-color-secondary;
        cursor: pointer;
        &:hover {
            color: @primary-color;
        }
    }
    .assign-room-label {
        margin-right: @padding-xs;
    }
    .assign-checkin-item {
        display: flex;
        align-items: center;
        &:not(:first-child) {
            margin-top: 2px;
        }
    }
    .assign-checkin-name {
        margin-right: @padding-xs;
    }
    .assign-checkin-mobile {
        color: @text-color-secondary;
    }
    .assign-annex-item {
        color: @primary-color;
        cursor: pointer;
        &:not(:first-child) {
            margin-top: 2px;
        }
    }
    .assign-room-empty {
        margin-top: @padding-sm;
    }
</style>
